export const Feature = async (element) => {
  const featureText = element.querySelector(".feature__text");
  if (featureText.children.length === 0) {
    featureText.remove();
  }
};
